<template>
  <tbody class="tbody-res">
  <tr>
    <td>{{ item.lata }}</td>
    <td>{{ item.rate_center }}</td>
    <td>{{ item.state }}</td>
    <td>{{ item.telephone_number }}</td>
    <td>
      <x-icon size="1.5x" class="custom-class"></x-icon>
    </td>
  </tr>
  </tbody>
</template>

<script>
import { XIcon } from 'vue-feather-icons'
export default {
  components: {
    XIcon
  },
  name: "QueueItems",
  props: {
    initialItem: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      item: this.initialItem,
    }
  },
}
</script>

<style scoped lang="scss">
tr {
  border-spacing: 10px 0;

  td {
    padding-left: 10px;
    padding-bottom: 15px;
    padding-top: 10px;
    .custom-class {
      color: rgba(255, 0, 0, 0.66);
    }
  }
}
</style>
